import React, {useEffect, useState} from 'react'
import {Button, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {GetAllData, GetData, removeData} from '../SubscriberSlice/SubscriberSlice'
import {stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {
  totalRecipients,
  totalUnsubscribedContactCount,
} from '../../../new-message/BulkMessageSlice/BulkMessageSlice'
import {useLocation} from 'react-router-dom'
import {useContact} from '../../../../../hooks/useContact'
import { getIsDefaultRegion } from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'

const RepotOfSubcriberUpload = ({ReportData, show, handleClose}: any) => {
  const dispatch = useDispatch()
  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const {actions} = useContact("RepotOfSubcriberUpload")

  const location = useLocation()

  const [isShowList, setIsShowList] = useState(false)
  const [showUniversalUnsub, setUniversalUnsub] = useState(true)

  useEffect(() => {
    if (location.pathname === '/contacts/list') {
      setIsShowList(true)
      setUniversalUnsub(false)
    } else {
      setIsShowList(false)
      setUniversalUnsub(true)
    }
  }, [location])

  return (
    <>
      <Modal
        backdrop='static'
        onHide={handleClose}
        show={show}
        dialogClassName='modal-dialog-centered'
      >
        <div className='modal-header'>
          <h1>Upload successful</h1>
          <div
            className='btn btn-icon btn-sm'
            onClick={() => {
              handleClose()
              dispatch(stopLoading())
              dispatch(removeData(ReportData))
              dispatch(GetAllData({id: groupid}))
              dispatch(
                totalRecipients({
                  to: {
                    selectedType: 'all',
                    value: 'all',
                  },
                })
              )
              groupid && dispatch(totalUnsubscribedContactCount(groupid))
              dispatch(GetData())
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body report'>
          <div className='card bg-secondary'>
            <div className='card-body '>
              <div className='row'>
                <div className='col-6 summary_block'>
                  <span className='bg-white p-2 me-2 rounded'>
                    <KTSVG
                      path='/media/icons/duotune/communication\com005.svg'
                      className='svg-icon-2x mb-2'
                    />
                  </span>
                  <div className='summary_content'>
                    <span>
                      <strong>{ReportData?.importedContact}</strong>
                    </span>
                    <p className='text-muted'>New Contacts</p>
                  </div>
                </div>
                <div className='col-6 summary_block'>
                  <span className='bg-white p-2 me-2 rounded'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen028.svg'
                      className='svg-icon-2x mb-2'
                    />
                  </span>
                  <div className='summary_content'>
                    <span>
                      <strong>{ReportData?.duplicatedContact}</strong>
                      <p className='text-muted'>Duplicates in List</p>
                    </span>
                  </div>
                </div>
                {/* <div className='col-6 summary_block'>
                  <span className='bg-white p-2 me-2 rounded'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-2x mb-2'
                    />
                  </span>
                  <div className='summary_content'>
                    <span>
                      <strong>{ReportData?.invalidContact}</strong>
                    </span>
                    <p className='text-muted'>Invalid Numbers</p>
                  </div>
                </div> */}
                {showUniversalUnsub && (
                  <div className='col-6 summary_block'>
                    <span className='bg-white p-2 me-2 rounded'>
                      <KTSVG
                        path='/media/icons/duotune/general/gen040.svg'
                        className='svg-icon-2x mb-2'
                      />
                    </span>
                    <div className='summary_content'>
                      <span>
                        <strong>{ReportData?.universalUnSub}</strong>
                      </span>
                      <p className='text-muted'>Universal Unsub</p>
                    </div>
                  </div>
                )}

                {/* <div className='col-6 summary_block'>
                  <span className='bg-white p-2 me-2 rounded'>
                    <KTSVG
                      path='/media/icons/duotune/communication\com005.svg'
                      className='svg-icon-2x mb-2'
                    />
                  </span>
                  <div className='summary_content'>
                    <span>
                      <strong>0</strong>
                    </span>
                    <p className='text-muted'>New Segment</p>
                  </div>
                </div> */}
                {isShowList ? (
                  <>
                    {ReportData && ReportData?.tagsCount > 0 && (
                      <div className='col-6 summary_block'>
                        <span className='bg-white p-2 me-2 rounded'>
                          <KTSVG
                            path='/media/icons/duotune/general/gen040.svg'
                            className='svg-icon-2x mb-2'
                          />
                        </span>
                        <div className='summary_content'>
                          <span>
                            <strong>{ReportData?.tagsCount}</strong>
                          </span>
                          <p className='text-muted'>List</p>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className='col-6 summary_block'>
                    <span className='bg-white p-2 me-2 rounded'>
                      <KTSVG
                        path='/media/icons/duotune/general/gen040.svg'
                        className='svg-icon-2x mb-2'
                      />
                    </span>
                    <div className='summary_content'>
                      <span>
                        <strong>{ReportData?.tagsCount}</strong>
                      </span>
                      <p className='text-muted'>New Tag</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* {ReportData?.invalidContact > 0 ? (
            <div className='mt-5'>
              <p className='mb-0'>
                Invalid numbers: landlines, too many or not enough numbers, or notmobile numbers.
                <a href={ReportData?.reportUrl}>Download error report</a>
              </p>
            </div>
          ) : null} */}
        </div>
        <div className='modal-footer pt-0 ms-auto me-0 d-flex'>
          <Button
            className='btn btn-light-primary'
            onClick={() => {
              if (ReportData?.reportUrl) {
                window.open(ReportData.reportUrl, '_self');
              }
            }}
          >
            Download Report
          </Button>
          <Button
            className='btn btn-primary'
            onClick={() => {
              dispatch(stopLoading())
              dispatch(removeData(ReportData))
              handleClose()
              dispatch(GetAllData({id: groupid}))
              dispatch(
                totalRecipients({
                  to: {
                    selectedType: 'all',
                    value: 'all',
                  },
                })
              )
              groupid && dispatch(totalUnsubscribedContactCount(groupid))
              actions.setTriggerFetch()

              if (!isDefaultRegion && location.pathname === '/contacts/subscriber') {
                window.location.reload()
              }
            }}
          >
            Done
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default RepotOfSubcriberUpload
